// Port of api/fuel/app/classes/controller/api/monty/misc/suggest/play/usernames.php
import DB from 'offline/db'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: [] } })
	var rows = DB.query("SELECT DISTINCT player_username, player_name FROM player WHERE (LOWER(player_username) LIKE '%" + text.replace(/'/g, "''") + "%' OR LOWER(player_name) LIKE '%" + text.replace(/'/g, "''") + "%') AND player_name <> '' LIMIT 25")
	var suggestions = rows.map(function(r) { return { username: r.player_username, name: r.player_name } })
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
